import { mixed, object } from 'yup';

import { InternalUrl } from '../deep-linking/deep-linking.types';
import { isInternalUniversalLinkTest } from '../deep-linking/deep-linking.schema';

export const PushNotificationDataSchema = object({
  url: mixed<InternalUrl>().test({
    name: 'is-internal-universal-link',
    // it's a yup template
    // eslint-disable-next-line no-template-curly-in-string
    message: '${value} must be a valid internal URL.',
    test: isInternalUniversalLinkTest,
  }),
}).strip();
